import * as $ from 'jquery';
import 'jquery-colorbox';

// $('a.gallery__imageWrap').colorbox({rel:'gal'});
  

$('a.gallery__imageWrap').colorbox({
	rel: 'gal',
	transition: 'elastic',
	initialWidth: '200',
	initialHeight: '200',
	width: '1204',
	maxWidth: '85%',
	maxHeight: '85%',
	fixed: true,
	reposition: true,
	close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.33 16.84">\
				<path fill="#384436" d="M13.46 15.34l1.48-1.49 15.35 15.34-1.49 1.49z" transform="translate(-12.96 -13.85)"/>\
				<path fill="#384436" d="M13 29.2l15.31-15.34 1.48 1.48-15.34 15.35z" transform="translate(-12.96 -13.85)"/>\
			</svg>'
});